module.exports = __webpack_public_path__ + "assets/img/warrior-name-a2fd4ccb.png";